import { useEffect } from 'react'
import posthog from 'posthog-js'
import { toast } from 'sonner'

const TRANSLATED_CLASSES = ['translated-ltr', 'translated-rtl']

const isTranslated = () =>
  TRANSLATED_CLASSES.some((translatedClass) =>
    document.documentElement.classList.contains(translatedClass)
  )

function BrowserTranslateDetector() {
  useEffect(() => {
    let reported = false
    const report = () => {
      if (reported || !isTranslated()) return
      reported = true
      // Super property — pripne sa na všetky ďalšie eventy vrátane `$exception` (ex Sentry.setTag).
      posthog.register({ browser_translator: 'active' })
      posthog.capture('browser_translate_detected')
      console.warn(
        '[BrowserTranslateDetector] Browser translation is active. ' +
          'This may cause React rendering errors.'
      )
      toast.warning(
        'Máte zapnutý prekladač stránok. Pre správnu funkčnosť stránky ho prosím vypnite.',
        {
          position: 'bottom-right',
          closeButton: true,
          duration: Infinity,
        }
      )
    }

    report()

    const observer = new MutationObserver(report)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    })

    return () => observer.disconnect()
  }, [])

  return null
}

export { BrowserTranslateDetector }
